import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-order-type-dialog',
    templateUrl: './order-type-dialog.component.html',
    styleUrls: ['./order-type-dialog.component.scss'],
    standalone: false
})
export class OrderTypeDialogComponent {
  orderType = '1';
  customerName!: string | null;
  customerPhone!: string | null;

  constructor(
    public dialogRef: MatDialogRef<OrderTypeDialogComponent>,
  ) {
  }

  onSelectOrderType() {
    if (this.orderType) {
      this.dialogRef.close({
        orderType: this.orderType,
        customerName: this.customerName,
        customerPhone: this.customerPhone
      });
    }
  }
}
